<script lang="ts" setup>
  import CuratedDeals from "@/components/views/rewards/CuratedDeals.vue";
  import cardSuccessImage from '@/assets/images/card-success.png';
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";

  const subscriptionFlowStore = useSubscriptionFlowStore();
</script>

<template>
  <div class="content">
    <div class="card-link-success">
      <div class="title">
        <div class="t-title-1 t-bold">
          <img :src="cardSuccessImage" width="50" height="50" alt="">
        </div>
        <div class="t-body-1 mt-4 message">
          {{ $t('modal.link.card.membership_activated')  }}
        </div>
        <div class="t-body-1 mt-4">
          {{ $t('modal.link.card.enjoy_benefits')  }}
        </div>

      </div>
      <CuratedDeals :show-title="false" style="width:100%;"/>
      <v-btn color="primary" class="card-link-description" @click="subscriptionFlowStore.close">
        {{ $t('modal.link.card.success.cta') }}
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .message {
    font-weight: 700;
    font-size: 18px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    text-align: center;
    min-height: 450px;
    height: 450px;

    .card-link-success {
      height: 100%;
      max-width: 900px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    @media screen and (max-width: breakpoint(md) - 1px) {
      .card-link-success {
        width: 100%;
      }
    }

  }
</style>
